/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import React, {ReactElement} from 'react';
import {AwesomeIcon} from '@dvrd/dvr-controls';
import BolReturn from "../models/bolReturnModel";
import Image from "../components/misc/image";
import {AccessKey} from "./interfaces";

export enum ReturnOptionType {DETAILS, CREDIT, INVOICE, CREDIT_INVOICE, SEND, BOL}

export type ReturnOption = {
    label: string;
    type: ReturnOptionType;
    icon: ReactElement;
    disabled?: boolean;
    accessKey: AccessKey
};

export function getReturnOptions(bolReturn: BolReturn): ReturnOption[] {
    const options: ReturnOption[] = [
        {
            label: 'Details',
            type: ReturnOptionType.DETAILS,
            icon: <AwesomeIcon name='list' className='icon'/>,
            accessKey: AccessKey.RETURN_DETAILS
        },
    ];
    if (bolReturn.invoiceId)
        options.push({
            label: 'Originele factuur',
            type: ReturnOptionType.INVOICE,
            icon: <AwesomeIcon name='receipt' className='icon'/>,
            accessKey: AccessKey.INVOICE_DETAILS,
        });
    if (bolReturn.creditInvoiceId)
        options.push({
                label: 'Creditfactuur',
                type: ReturnOptionType.CREDIT_INVOICE,
                icon: <AwesomeIcon name='euro-sign' className='icon'/>,
                accessKey: AccessKey.INVOICE_DETAILS
            },
            {
                label: 'Creditfactuur verzenden',
                type: ReturnOptionType.SEND,
                icon: <AwesomeIcon name='paper-plane' className='icon'/>,
                accessKey: AccessKey.RETURN_SEND_CREDIT
            });
    else options.push({
        label: 'Crediteren',
        type: ReturnOptionType.CREDIT,
        icon: <AwesomeIcon name='euro-sign' className='icon'/>,
        accessKey: AccessKey.RETURN_CREATE_CREDIT
    });
    options.push({
        label: 'Weergeven in Bol',
        type: ReturnOptionType.BOL,
        icon: <Image name='bol-16' className='icon' alt='Bol'/>,
        accessKey: AccessKey.RETURN_BOL
    })
    return options;
}